import React from "react";
import { Link } from "react-router-dom";
import './ExperienceSection.css';
import '../ProjectsSection/ProjectsSection.css';
import gifImg from './images/gif23.gif';
import gifImg2 from './images/gif2.gif';
export default function ExperienceSection(){
    return(
        <div className="ExperienceSection container-fluid experience_section_parent_wrapper">
            <div className="experience_section_child_wrapper">
                <div className="container experience_content_wrapper">
                    <h4 className="project_heading font-weight-bold">
                        Projects
                    </h4>
                    <div className="row gx-2 gy-4 project_row mt-5">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-4">
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={gifImg} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                                <div className="card-body d-flex flex-column h-100">
                                    <div className="d-md-none mobile_heading mt-3" style={{rowGap:10,columnGap:"4pt"}}>
                                        <div>
                                            <h6 className="py-2 px-3">
                                                UX Design + Writing
                                            </h6>
                                        </div>
                                        <div>
                                            <h6 className="py-2 px-3">
                                                Development 
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="categories_section mt-2 d-none d-sm-none d-md-flex">
                                        <p className="category_item border-outline-dark px-3 py-1">
                                            UX Design + Writing
                                        </p>
                                        <p className="category_item border-outline-dark px-3 py-1">
                                            Development
                                        </p>
                                    </div>
                                    <h4 className="card-title ux_card_title font-weight-bolder mt-2">
                                        ClassroomInsights AI Website
                                    </h4>
                                    <p className="card-description ux_card_description mt-2">
                                        I was responsible for overseeing the project from the UX/UI design process to the 
                                        final Development process.Contributed as a UX writer to some of the sections :
                                    </p>
                                    <p className=""><b>If the official website is down visit 
                                        <Link className="text-danger" to="https://faithseasonsdesign.github.io/classroomai/">Link</Link> &nbsp;
                                        </b></p>
                                    <div className="ux_section_btn_wrapper mt-2">
                                        <button className="btn btn-sm ux_section_view_btn work_btn text-white px-4 py-2">
                                            <Link className='ux_section_link text-white' to='https://classroominsightsai.co.za/'>
                                                <span>
                                                    Check Out Website
                                                </span>
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-4">
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={gifImg2} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                                <div className="card-body d-flex flex-column h-100">
                                <div className="d-md-none mobile_heading mt-3" style={{rowGap:10,columnGap:"4pt"}}>
                                        <div>
                                            <h6 className="py-2 px-3">
                                                UX Design + Writing
                                            </h6>
                                        </div>
                                        <div>
                                            <h6 className="py-2 px-3">
                                                Development 
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="categories_section mt-2 d-none d-sm-none d-md-flex">
                                        <p className="category_item border-outline-dark px-3 py-1">
                                            UX Design + Writing
                                        </p>
                                        <p className="category_item border-outline-dark px-3 py-1">
                                            Development
                                        </p>
                                    </div>
                                    <h4 className="card-title ux_card_title font-weight-bolder mt-2">
                                        A2Z Tech Shop
                                    </h4>
                                    <p className="card-description ux_card_description mt-2">
                                        I was responsible for overseeing the project from the UX/UI design process to the 
                                        final Development process.I was responsible for assets creation and editing
                                    </p>
                                    <p className=""><b>If the official website is down visit 
                                        <Link className="text-danger" to="https://faithseasonsdesign.github.io/a2ztech_store/">Link</Link>&nbsp;
                                        this was the inital development , view the final one on the GIF
                                        </b></p>
                                    <div className="ux_section_btn_wrapper mt-2">
                                        <button className="btn btn-sm ux_section_view_btn work_btn text-white px-4 py-2">
                                            <Link className='ux_section_link text-white' to='https://a2zshop.co.za/'>
                                                <span>
                                                    Check Out Website
                                                </span>
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <h3 className="background_title font-weight-bolder mt-4">
                        Other Contributions & Highlights
                    </h3>
                    <ul className="list_wrapper">
                        <li className="font-weight-bolder mt-4">
                            I am Currently part of a R&D + marketing team that  Helped Grow Our Social Media Following by 35%
                            I am a graphic designer delivering colliteral for social media as well as a contributer to the social media strategies
                        </li>
                        <li className="mt-3">
                            We recently hit 1000 followers on LinkedIn from 200 followers
                        </li>
                        <li className="mt-3">
                            Delivered about 2 systems and 3 Website in the Research & Development team 
                            in a period of 7 months
                        </li>
                        <li className="mt-3">
                            Assist with doing research ,
                            coming up with frameworks & strategies to grow our social media and 
                            our brand and company in general
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}